/*  Loop Subscription Bundle Snippet v3.5

Created and maintained by LOOP SUBSCRIPTIONS (https://apps.shopify.com/loop-subscriptions)
DO NOT modify source code of this file because
- It is an automatically generated file from LOOP SUBSCRIPTIONS backend.
- LOOP SUBSCRIPTIONS will keep releasing new versions of this file. You can check the latest version
  available by visiting Loop Admin > Bundles > Snippets > Install bundle snippet.
- Updating will replace the existing file implying that all the custom code on the existing file
  (if any) will be lost.
- If you need to make changes, please do it using our standard bundle style settings available inside each bundle details page on Loop admin portal.
If you need any help, please contact us at support@loopwork.co.
*/

const BUNDLE_LINK_PREFIX = "/a/loop_subscriptions/bundle";
const LOOP_BUNDLE_URL = "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";
let BUNDLE_CONTAINER_CLASS = "BUNDLE_CONTAINER_CLASS";
let CART_SUBTOTAL_CLASS = "CART_SUBTOTAL_CLASS";

const isValidBundleId = (bundleId) => {
    return (
        typeof bundleId === "string" &&
        /^([0-9a-f]{32}|[0-9A-Z]{26})$/.test(bundleId)
    );
};

const bundleIdRegistry = new Map();

const generateBundleRef = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const random = crypto.getRandomValues(new Uint8Array(1))[0] & 15;
        const value = char === "x" ? random : (random & 0x3) | 0x8;
        return value.toString(16);
    });
};

//dev
// const LOOP_BUNDLE_URL =
//   "https://dev-api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
// const LOOP_API_SERVICE_URL = "https://dev-api-service.loopwork.co";

//prod
// const LOOP_BUNDLE_URL =
//   "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails";
// const LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";

const getItemsHtmlLoop = (item, bundleQuantityMapping) => {
    let quantity = item.quantity;
    if (bundleQuantityMapping) {
        let variant = bundleQuantityMapping.find(
            (v) => v.childProductId === item.id
        );
        if (variant) {
            quantity = variant.quantity;
        }
    }
    return `<p><span style="display:block;" class="data-cart-item-selling-plan-name">${
        item.title || ""
    } x ${quantity || ""}</span></p>`;
};

const getEditCartButton = (bundleRef, editBtnText = "Edit") => {
    return `<button class="loop-edit-bundle-btn" data-bundle-ref="${bundleRef}" style="background:none;border:none;display:flex;align-items:center;gap:3px;cursor:pointer;padding:0; text-decoration:underline;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 17 17">
            <path fill-rule="evenodd" d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"></path>
        </svg>
        <p style="padding:0px;margin:0px;margin-top:5px">${
            editBtnText ?? "Edit"
        }</p>
    </button>`;
};


const healthy7CartEscape = (value) => String(value ?? "")
    .replaceAll("&", "&amp;").replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#39;");

// Use the same money settings and custom element as Be Yours' Liquid rows.
const healthy7CartMoney = (cents) => {
    const settings = window.theme?.shopSettings;
    const format = settings?.currencyCode
        ? settings.moneyWithCurrencyFormat : settings?.moneyFormat;
    let text;
    if (format && window.theme?.Currency?.formatMoney) {
        text = window.theme.Currency.formatMoney(Math.round(cents), format);
    } else {
        const currency = window.Shopify?.currency?.active || "CAD";
        text = new Intl.NumberFormat(window.Shopify?.locale || "en", {
            style: "currency", currency, currencyDisplay: "narrowSymbol"
        }).format(cents / 100);
        if (settings?.currencyCode) text += " " + currency;
        text = healthy7CartEscape(text);
    }
    return `<price-money><bdi>${text}</bdi></price-money>`;
};

const healthy7FullCartBundleTemplate = (bundleItem, index, bundleLink, preset) => {
    const esc = healthy7CartEscape;
    const items = bundleItem.items || [];
    // Shopify's line totals are already in cents and include line discounts.
    const total = items.length
        ? items.reduce((sum, item) => sum + Number(item.final_line_price), 0)
        : Number(bundleItem.final_line_price) * 100;
    const original = items.length
        ? items.reduce((sum, item) => sum + Number(item.original_line_price ?? item.final_line_price), 0)
        : total;
    const quantity = preset ? Math.max(1, Number(bundleItem.bundleProductQuantity) || 1) : 1;
    const price = (amount, oldAmount) => oldAmount > amount
        ? `<dl class="cart-item__discounted-prices"><dt class="visually-hidden">Regular price</dt><dd class="price--on-sale"><s class="cart-item__old-price price price-item--regular price--end">${healthy7CartMoney(oldAmount)}</s></dd><dt class="visually-hidden">Sale price</dt><dd class="price price--end">${healthy7CartMoney(amount)}</dd></dl>`
        : `<span class="price price--end">${healthy7CartMoney(amount)}</span>`;
    const meals = items.map(item => {
        const mapped = bundleItem.bundleQuantityMapping?.find(entry => entry.childProductId === item.id);
        return `<p style="display:block"><span>${esc(item.product_title || item.title)} × ${esc(mapped?.quantity ?? item.quantity)}</span></p>`;
    }).join("");
    // Avoid cart-remove-button: its theme handler removes one indexed Shopify
    // line; the existing Loop delegated handler must remove the whole bundle.
    return `<tr class="cart-item tpo_ignore" id="CartBundleItem-${index}">
      <td class="cart-item__media"><a href="${esc(bundleLink)}" class="media-wrapper media-wrapper--small" aria-hidden="true" tabindex="-1"><img class="cart-item__image" src="${esc(bundleItem.image || "")}" alt="" loading="lazy" width="150" height="150"></a></td>
      <td class="cart-item__details">
        <a href="${esc(bundleLink)}" class="cart-item__name link">${esc(bundleItem.label)}</a>
        <div class="product-option">${meals}</div>
        ${bundleItem.sellingPlan ? `<p class="product-option">${esc(bundleItem.sellingPlan)}</p>` : ""}
        ${bundleItem.discountTitle ? `<ul class="discounts list-unstyled" role="list"><li class="discounts__discount">${esc(bundleItem.discountTitle)}</li></ul>` : ""}
        ${preset ? "" : getEditCartButton(bundleItem.bundleRef, esc(bundleItem.editBtnText ?? "Edit")).replace("<button ", '<button type="button" ')}
      </td>
      <td class="cart-item__prices small-hide right"><div class="cart-item__price-wrapper">${price(total / quantity, original / quantity)}</div></td>
      <td class="medium-hide large-up-hide right"><div class="cart-item__price-wrapper">${price(total, original)}</div></td>
      <td class="cart-item__quantity">${quantity > 1 ? `<span aria-label="Bundle quantity">${quantity}</span>` : '<span class="visually-hidden">1 bundle</span>'}</td>
      <td class="cart-item__totals right">
        <div class="cart-item__price-wrapper medium-up">${price(total, original)}</div>
        <button type="button" class="button button--tertiary loop-bundle__full-cart-remove loop-remove-bundle-btn" data-bundle-ref="${esc(bundleItem.bundleRef)}" aria-label="Remove ${esc(bundleItem.label)}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
        </button>
      </td>
    </tr>`;
};

const getBundleCartTableTemplateLoop = (bundleItem, index, bundleLink) =>
    healthy7FullCartBundleTemplate(bundleItem, index, bundleLink, false);

const getBundleCartDrawerTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
          <td class="cart-item__media" style="text-align:center;">
            <img class="cart-item__image"
              src="${bundleItem.image || ""}"
              alt="${bundleItem.label}" loading="lazy" width="75" height="75">
          </td>
          <td class="cart-item__details">
            <a href="${bundleLink}"
              class="cart-item__name break">
              ${bundleItem.label || ""}
            </a>
            <dl>
              <div class="product-option">
                ${bundleItem.items
                    .map((item) => getItemsHtmlLoop(item))
                    .join("")}
                  <br/>
                  <p><span class="data-cart-item-selling-plan-name">
                    ${bundleItem.sellingPlan || ""}
                  </span></p>
              </div>
            </dl>
          </td>
          <td class="cart-item__quantity small-hide">
            ${bundleItem.quantity}
          </td>
          <td class="right medium-hide large-up-hide">
            <div class="cart-item__price-wrapper medium-up" style="display: flex; gap: 10px;">
              ${
                  bundleItem.priceWithoutDiscount !== bundleItem.price
                      ? `<span class="price price--end" style="text-decoration:line-through;">
                    ${bundleItem.priceWithoutDiscount}
                </span>`
                      : ""
              }
              <span class="price price--end" style="font-weight: 600;">
                ${bundleItem.price}
              </span>
            </div>
            ${getEditCartButton(bundleItem.bundleRef, bundleItem.editBtnText)}
            <div class="loop-remove-bundle-btn" data-bundle-ref="${
                bundleItem.bundleRef
            }" style="cursor:pointer; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </td>
        </tr>
    `;
};

const getBundleCartItemsDivTemplateLoop = (bundleItem, index, bundleLink) => {
    return `
        <div style="display:flex; gap:20px; justify-content: space-between;" id="CartBundleItem-${index}">
          <div style="display:flex; gap:20px;">
            <div style="text-align:center;">
              <img
                src="${bundleItem.image || ""}"
                alt="${bundleItem.label}" loading="lazy" width="75" height="75">
            </div>
            <div>
              <a href="${bundleLink}"
                 style="font-weight:600">
                ${bundleItem.label || ""}
              </a>
              <div>
                ${bundleItem.items
                    .map((item) => getItemsHtmlLoop(item))
                    .join("")}
                  <br/>
                  <p><span>${bundleItem.sellingPlan || ""}</span></p>
              </div>
            </div>
          </div>
          <div>
            ${bundleItem.quantity}
          </div>
          <div>
            <div style="display: flex; gap: 10px;">
                ${
                    bundleItem.priceWithoutDiscount !== bundleItem.price
                        ? `<span style="text-decoration:line-through;">
                        ${bundleItem.priceWithoutDiscount}
                    </span>`
                        : ""
                }
              <span style="font-weight: 600;">${bundleItem.price}</span>
            </div>
            ${getEditCartButton(bundleItem.bundleRef, bundleItem.editBtnText)}
            <div class="loop-remove-bundle-btn" data-bundle-ref="${
                bundleItem.bundleRef
            }" style="cursor:pointer; vertical-align: text-top; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
    `;
};

const getPresetBundleCartTemplateLoop = (bundleItem, index, bundleLink) =>
    healthy7FullCartBundleTemplate(bundleItem, index, bundleLink, true);

const getPresetBundleCartDrawerTemplateLoop = (
    bundleItem,
    index,
    bundleLink
) => {
    return `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${
                bundleItem.image || ""
            }"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="${bundleLink}" class="cart-item__name h4 break">${
        bundleItem.label
    }</a>
                <div class="product-option">
            ${bundleItem.items
                .map((item) =>
                    getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)
                )
                .join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.eachBundleAmount}
        </div><dl></dl>

        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
            bundleItem.discountTitle
                ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
                : ""
        }
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price}
          </span></div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="${
              bundleItem.bundleProductQuantity
          }" min="0">
        </quantity-input>
        <cart-remove-button>
          <a class="button button--tertiary loop-remove-bundle-btn" data-bundle-ref="${
              bundleItem.bundleRef
          }" aria-label="${bundleItem.label}" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price_currency}
          </span></div>
    </td>
  </tr>
    `;
};

// returns cart item key of a bundleId
const getItemKeysByBundleIdLoop = (bundleId) => {
    const cartItems = window.Loop.bundleCartAllItems;
    const data = {
        updates: {},
    };
    for (const item of cartItems) {
        const _bundleId =
            item?.properties?._bundleId ?? item?.properties?.bundleId;
        if (!_bundleId || _bundleId !== bundleId) continue;
        data.updates[item.key] = 0;
    }
    return data;
};

// removes a bundleId from cart
const removeBundleLoop = async (bundleId) => {
    const data = getItemKeysByBundleIdLoop(bundleId);
    const endpoint = `${window.Shopify.routes.root}cart/update.js`;
    await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    window.location.href = window.location.href;
};

const changeBundleCartItems = async (bundleTransactionId) => {
    disableEditButton();
    const currentLocale = window?.Shopify?.locale;
    const root = window?.Shopify?.routes?.root ?? "/";

    if (bundleTransactionId) {
        const _editBundleRef = `${BUNDLE_LINK_PREFIX}/change/${bundleTransactionId}`;
        if (currentLocale && root !== "/") {
            window.location.href = `/${currentLocale}${_editBundleRef}`;
        } else {
            window.location.href = _editBundleRef;
        }
    }
};

const disableEditButton = (bundleId) => {
    console.log(`disabling bundle edit button: ${bundleId}`);
    const editButttons = document.querySelectorAll(
        `loop-edit-bundle-${bundleId}`
    );
    for (const button of editButttons) {
        button.disabled = true;
    }
};

const fetchLoopBundleTransactionCartDetails = async (loopBundleGuid) => {
    const { locale } = window.Shopify;
    const _locale = locale.split("-")[0];
    const _endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}?locale=${_locale}`;
    const _response = await fetch(_endpoint);
    return await _response.json();
};

// Helper function to format price using Intl
const formatPrice = (amount, currencyCode = null) => {
    const currency = currencyCode || window?.Shopify?.currency?.active || "USD";
    const locale = window?.Shopify?.locale || "en";

    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (error) {
        // Fallback if Intl fails
        console.error("Error formatting price:", error);
        return `${currency} ${amount.toFixed(2)}`;
    }
};

const addExtraDetailsToBundleItemsLoop = async (bundleItems) => {
    let totalDiscount = 0;
    let currencyCode = "";

    // Get the exchange rate for currency conversion (default to 1 if not available)
    const exchangeRate = window?.Shopify?.currency?.rate || 1;

    // Get active currency code
    currencyCode = window?.Shopify?.currency?.active;

    const fetchDetailsPromises = bundleItems.map((bundleItem) =>
        fetchLoopBundleTransactionCartDetails(bundleItem.bundleId)
    );
    const allExtraDetails = await Promise.all(fetchDetailsPromises);
    for (let i = 0; i < allExtraDetails.length; ++i) {
        const extraDetails = allExtraDetails[i];
        const bundleItem = bundleItems[i];
        const quantityMapping =
            extraDetails?.variantMap?.[bundleItem.bundleId] ?? [];
        const isPresetBundleProduct = bundleItem.isPresetBundleProduct;
        const totalBundleItemsQuantity = bundleItem.items.reduce(
            (acc, item) => acc + item.quantity,
            0
        );
        let price = isPresetBundleProduct
            ? bundleItem.discounted_price
            : bundleItem.price;

        bundleItem.label = extraDetails?.label;
        bundleItem.image = extraDetails?.image;
        bundleItem.sellingPlan = extraDetails?.name;
        bundleItem.editBtnText = extraDetails.editBtnText ?? "Edit";
        bundleItem.priceWithoutDiscount = formatPrice(price, currencyCode);
        bundleItem.final_line_price_currency = formatPrice(
            parseFloat(bundleItem.final_line_price),
            currencyCode
        );
        bundleItem.loopBundleId = extraDetails.loopBundleId;

        if (
            extraDetails.discountType &&
            extraDetails.discountValue &&
            !isPresetBundleProduct
        ) {
            if (extraDetails.discountType === "PERCENTAGE") {
                if (extraDetails.appliesOnEachItem) {
                    // if discount in each item
                    totalDiscount +=
                        price *
                        (parseFloat(extraDetails.discountValue) / 100) *
                        totalBundleItemsQuantity;
                    price =
                        price -
                        price *
                            (parseFloat(extraDetails.discountValue) / 100) *
                            totalBundleItemsQuantity;
                } else {
                    totalDiscount +=
                        price * (parseFloat(extraDetails.discountValue) / 100);
                    price =
                        price -
                        price * (parseFloat(extraDetails.discountValue) / 100);
                }
            } else {
                // Fixed amount discount - convert from store currency to customer's currency
                const convertedDiscountValue =
                    parseFloat(extraDetails.discountValue) * exchangeRate;

                if (extraDetails.appliesOnEachItem) {
                    // if discount in each item
                    totalDiscount +=
                        convertedDiscountValue * totalBundleItemsQuantity;
                    price =
                        price -
                        convertedDiscountValue * totalBundleItemsQuantity;
                } else {
                    totalDiscount += convertedDiscountValue;
                    price = price - convertedDiscountValue;
                }
            }
        }

        bundleItem.price = formatPrice(parseFloat(price), currencyCode);

        if (extraDetails?.productsQuantity) {
            bundleItems[i]["bundleProductQuantity"] =
                extraDetails.productsQuantity;
            bundleItems[i]["eachBundleAmount"] = formatPrice(
                parseFloat(
                    bundleItems[i].final_line_price /
                        extraDetails.productsQuantity
                ),
                currencyCode
            );
        } else {
            bundleItems[i]["bundleProductQuantity"] = 1;
            bundleItems[i]["eachBundleAmount"] = formatPrice(
                parseFloat(price / 1),
                currencyCode
            );
        }
        if (quantityMapping.length) {
            bundleItem.bundleQuantityMapping = quantityMapping;
        }
        if (isPresetBundleProduct) {
            bundleItem.productHandle = extraDetails.product_handle;
        }
    }

    removeDiscountFromSubtotalInCartLoop(totalDiscount, currencyCode);
};

const removeDiscountFromSubtotalInCartLoop = (totalDiscount, currencyCode) => {
    let targetNode = null;
    targetNode = document.querySelector(`.totals__subtotal-value`);
    if (targetNode) {
        applyDiscountByCartLineItemsLoop(
            targetNode,
            totalDiscount,
            currencyCode
        );
    }
};

function applyDiscountByCartLineItemsLoop(element, discount, currencyCode) {
    // The full-cart footer is rendered from Shopify's cart.total_price. A sum
    // of line prices cannot reproduce order-level discount-code allocations.
    if (element.hasAttribute("data-loop-shopify-total")) return;
    const totalLineItemsPrice = window.Loop.bundleCartAllItems.reduce(
        (acc, item) => {
            return (
                acc +
                (item.properties._isPresetBundleProduct
                    ? item.discounted_price
                    : item.price) *
                    item.quantity
            );
        },
        0
    );
    const discountedPrice = (
        (totalLineItemsPrice / 100).toFixed(2) - discount
    ).toFixed(2);

    if (!isNaN(discountedPrice)) {
        element.innerHTML = formatPrice(
            parseFloat(discountedPrice),
            currencyCode
        );
    }
}

const getBundleItemsLoop = (items) => {
    const bundleItemsMap = {};
    for (const item of items) {
        const bundleId =
            item?.properties?._bundleId ?? item?.properties?.bundleId;
        if (!bundleId || !isValidBundleId(bundleId)) continue;
        if (!Object.hasOwn(bundleItemsMap, bundleId)) {
            bundleItemsMap[bundleId] = {
                bundleId,
                quantity: 1,
                price: (Number(item.price) * Number(item.quantity)) / 100,
                amount: (Number(item.price) * Number(item.quantity)) / 100,
                items: [item],
                discounted_price:
                    (Number(item.discounted_price) * Number(item.quantity)) /
                    100,
                isPresetBundleProduct: item?.properties?._isPresetBundleProduct,
                discountTitle: item?.discounts?.[0]?.title ?? "",
                final_line_price: Number(item.final_line_price) / 100,
            };
        } else {
            bundleItemsMap[bundleId].price +=
                (Number(item.price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].discounted_price +=
                (Number(item.discounted_price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].amount +=
                (Number(item.price) * Number(item.quantity)) / 100;
            bundleItemsMap[bundleId].final_line_price +=
                Number(item.final_line_price) / 100;
            bundleItemsMap[bundleId].items.push(item);
        }
    }
    return sortItemsByTitleLoop(Object.values(bundleItemsMap));
};

const sortItemsByTitleLoop = (bundles) => {
    return bundles.map((bundle) => {
        bundle.items.sort((a, b) => {
            let titleA = a.title.toUpperCase();
            let titleB = b.title.toUpperCase();
            if (titleA < titleB) {
                return -1;
            }
            if (titleA > titleB) {
                return 1;
            }
            return 0;
        });
        return bundle;
    });
};

const renderBundleItemsLoop = (bundleItems, clientId) => {
    let _parent = document.querySelector(`.${clientId}`);
    if (!_parent) {
        _parent = document.querySelector(`.${BUNDLE_CONTAINER_CLASS}`);
    }
    if (!_parent) {
        return;
    }

    for (let i = 0; i < bundleItems.length; ++i) {
        let bundleItem = bundleItems[i];
        const bundleRef = generateBundleRef();
        bundleIdRegistry.set(bundleRef, bundleItem.bundleId);
        bundleItem.bundleRef = bundleRef;
        const _bundleLink = bundleItem.isPresetBundleProduct
            ? `https://${window.Shopify.shop}/products/${bundleItem.productHandle}`
            : `${BUNDLE_LINK_PREFIX}/${bundleItem.loopBundleId}`;
        let _template = undefined;
        let hasTable = document.getElementsByTagName("table");

        if (
            bundleItem["isPresetBundleProduct"] &&
            window.location.pathname === "/cart"
        ) {
            _template = getPresetBundleCartTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (
            bundleItem["isPresetBundleProduct"] &&
            window.location.pathname !== "/cart"
        ) {
            _template = getPresetBundleCartDrawerTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (clientId.includes("drawer") && hasTable.length) {
            _template = getBundleCartDrawerTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else if (hasTable.length) {
            _template = getBundleCartTableTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        } else {
            _template = getBundleCartItemsDivTemplateLoop(
                bundleItem,
                i + 1,
                _bundleLink
            );
        }
        _parent.innerHTML = `${_template} ${_parent.innerHTML}`;
    }

    if (!_parent.dataset.loopListenersAttached) {
        attachBundleEventListeners(_parent);
        _parent.dataset.loopListenersAttached = "true";
    }
};

const attachBundleEventListeners = (parent) => {
    parent.addEventListener("click", (event) => {
        const editBtn = event.target.closest(".loop-edit-bundle-btn");
        if (editBtn) {
            event.preventDefault();
            const bundleId = bundleIdRegistry.get(editBtn.dataset.bundleRef);
            if (bundleId) changeBundleCartItems(bundleId);
            return;
        }
        const removeBtn = event.target.closest(".loop-remove-bundle-btn");
        if (removeBtn) {
            const bundleId = bundleIdRegistry.get(removeBtn.dataset.bundleRef);
            if (bundleId) removeBundleLoop(bundleId);
        }
    });
};

async function getCartItemsLoop() {
    const url = `https://${Shopify.cdnHost.split("/cdn")[0]}/cart.json`;
    const res = await (await fetch(url)).json();
    return res?.items ?? [];
}

function setupMutationLoop(_bundleItems) {
    if (!_bundleItems?.length) return;

    if (window.location.pathname.includes("/a/loop_subscriptions/bundle")) {
        return;
    }

    let previousQuantity = window.Loop.bundleCartAllItems.reduce(
        (acc, curr) => acc + curr.quantity,
        0
    );
    let timeoutId;
    const handleChanges = async () => {
        const res = await getCartItemsLoop();
        let currenctQuantity = res.reduce(
            (acc, curr) => acc + curr.quantity,
            0
        );
        if (currenctQuantity !== previousQuantity) {
            window.location.reload();
        }
    };

    let targetNodes = document.querySelectorAll("form");
    const config = { childList: true, subtree: true };

    targetNodes.forEach((targetNode) => {
        const observer = new MutationObserver(() => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(handleChanges, 500);
        });
        observer.observe(targetNode, config);
    });
}

function setupMutationIfElementDelete() {
    let firstChange = true;
    let timeoutId;
    const handleChanges = () => {
        if (firstChange) {
            firstChange = false;
        } else {
            if (
                !window.location.pathname.includes(
                    "/a/loop_subscriptions/bundle"
                )
            ) {
                firstChange = true;
                window.location.reload();
            }
        }
    };

    let targetNode = document.querySelector(".cart-container");
    if (!targetNode) {
        targetNode = document.querySelector(".cart__blocks");
    }
    if (!targetNode) {
        return;
    }

    const observer = new MutationObserver(() => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(handleChanges, 1000);
    });
    const config = { childList: true, subtree: true };
    observer.observe(targetNode, config);
}

function setupMutationOldLoop() {
    var firstChange = true;
    let targetNode = null;
    let observerNode = null;
    targetNode = document.querySelectorAll(`[data-cart-subtotal]`);
    if ((targetNode && targetNode.length > 1) || !targetNode.length) {
        observerNode = document.querySelector(`.${CART_SUBTOTAL_CLASS}`);
    } else {
        observerNode = targetNode[0];
    }

    if (!observerNode) {
        return;
    }

    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        if (firstChange) {
            firstChange = false;
            return;
        } else {
            firstChange = true;
            setTimeout(window.location.reload(), 1000);
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(observerNode, config);
}


// Full-cart updates replace the .js-contents HTML without executing its inline
// init script. Render from each Shopify response, not from the initial cart.
let healthy7FullCartRenderSequence = 0;
const healthy7FullCartDetails = new Map();

const healthy7LoadFullCartDetails = (bundleId) => {
    const cached = healthy7FullCartDetails.get(bundleId);
    if (cached && cached.expires > Date.now()) return cached.promise;
    const entry = {
        expires: Date.now() + 30000,
        promise: fetchLoopBundleTransactionCartDetails(bundleId).catch((error) => {
            if (healthy7FullCartDetails.get(bundleId) === entry) {
                healthy7FullCartDetails.delete(bundleId);
            }
            console.warn("Unable to enrich full-cart Loop bundle:", error);
            return null;
        }),
    };
    healthy7FullCartDetails.set(bundleId, entry);
    return entry.promise;
};

const renderLoopBundleFullCart = async (cartItems) => {
    const sequence = ++healthy7FullCartRenderSequence;
    if (!Array.isArray(cartItems)) return;
    window.Loop = window.Loop || {};
    window.Loop.bundleCartAllItems = cartItems;

    const parent = document.querySelector("#MainContent #main-cart-items tbody");
    if (!parent) return;
    const bundles = getBundleItemsLoop(cartItems);
    bundles.forEach((bundle) => {
        const item = bundle.items[0] || {};
        bundle.label = item.properties?._bundleName || item.properties?.bundleName || "Meal Bundle";
        bundle.image = typeof item.image === "string" ? item.image : item.featured_image?.url || "";
        bundle.sellingPlan = item.selling_plan_allocation?.selling_plan?.name || "";
        bundle.editBtnText = "Edit";
        bundle.bundleRef = generateBundleRef();
        bundleIdRegistry.set(bundle.bundleRef, bundle.bundleId);
    });

    const paint = () => {
        if (sequence !== healthy7FullCartRenderSequence || !parent.isConnected) return;
        // Remove only synthetic rows; preserve real item rows, input handlers
        // and their Shopify/Easify positional mapping.
        const currentRefs = new Set(bundles.map(bundle => bundle.bundleRef));
        parent.querySelectorAll(':scope > [id^="CartBundleItem-"]').forEach((row) => {
            row.querySelectorAll("[data-bundle-ref]").forEach((button) => {
                if (!currentRefs.has(button.dataset.bundleRef)) {
                    bundleIdRegistry.delete(button.dataset.bundleRef);
                }
            });
            row.remove();
        });
        const html = bundles.map((bundle, index) => {
            const link = bundle.isPresetBundleProduct && bundle.productHandle
                ? `${window.Shopify?.routes?.root || "/"}products/${bundle.productHandle}`
                : bundle.loopBundleId
                    ? `${BUNDLE_LINK_PREFIX}/${bundle.loopBundleId}`
                    : `${BUNDLE_LINK_PREFIX}/change/${bundle.bundleId}`;
            return bundle.isPresetBundleProduct
                ? getPresetBundleCartTemplateLoop(bundle, index + 1, link)
                : getBundleCartTableTemplateLoop(bundle, index + 1, link);
        }).join("");
        parent.insertAdjacentHTML("afterbegin", html);
        if (!parent.dataset.loopListenersAttached) {
            attachBundleEventListeners(parent);
            parent.dataset.loopListenersAttached = "true";
        }
    };

    // Show Shopify prices immediately even if Loop's metadata request fails.
    paint();
    if (!bundles.length) return;
    await Promise.all(bundles.map(async (bundle) => {
        const details = await healthy7LoadFullCartDetails(bundle.bundleId);
        if (!details) return;
        bundle.label = details.label || bundle.label;
        bundle.image = details.image || bundle.image;
        bundle.sellingPlan = details.name || bundle.sellingPlan;
        bundle.editBtnText = details.editBtnText ?? bundle.editBtnText;
        bundle.loopBundleId = details.loopBundleId;
        bundle.productHandle = details.product_handle;
        bundle.bundleProductQuantity = details.productsQuantity || 1;
        bundle.bundleQuantityMapping = details.variantMap?.[bundle.bundleId] || [];
        // Do not recalculate cart totals or discounts from Loop metadata.
    }));
    if (sequence !== healthy7FullCartRenderSequence || !parent.isConnected) {
        bundles.forEach(bundle => bundleIdRegistry.delete(bundle.bundleRef));
        return;
    }
    paint();
};

window.renderLoopBundleFullCart = renderLoopBundleFullCart;
document.addEventListener("cart:updated", (event) => {
    if (Array.isArray(event.detail?.cart?.items)) {
        renderLoopBundleFullCart(event.detail.cart.items).catch((error) => {
            console.error("Unable to render full-cart Loop bundles:", error);
        });
    }
});

const initLoopBundle = async (clientId) => {
    if (document.querySelector("#MainContent #main-cart-items tbody")?.classList.contains(clientId)) {
        return renderLoopBundleFullCart(window.Loop?.bundleCartAllItems || []);
    }
    console.log(`Loop Bundle Initialized for ${clientId}`);
    const _cartItems = window.Loop.bundleCartAllItems;
    const _bundleItems = getBundleItemsLoop(_cartItems);
    await addExtraDetailsToBundleItemsLoop(_bundleItems);
    setupMutationLoop(_bundleItems);
    renderBundleItemsLoop(_bundleItems, clientId);
};

/* Healthy7 / Be Yours 9.2.0 cart drawer adapter.
 *
 * Loop's generated v3.5 file intentionally remains unchanged above this
 * boundary. The theme's mini-cart markup calls window.renderLoopBundleDrawer,
 * which is not provided by the stock Loop snippet. Everything below is scoped
 * to the Be Yours drawer and uses v3.5's validated bundle IDs + reference map.
 */
(() => {
    let drawerRenderRequest = 0;

    const escapeHtml = (value) =>
        String(value ?? "")
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");

    const ensureBundleRef = (bundleItem) => {
        if (
            bundleItem.bundleRef &&
            bundleIdRegistry.get(bundleItem.bundleRef) === bundleItem.bundleId
        ) {
            return bundleItem.bundleRef;
        }
        const bundleRef = generateBundleRef();
        bundleIdRegistry.set(bundleRef, bundleItem.bundleId);
        bundleItem.bundleRef = bundleRef;
        return bundleRef;
    };

    const moneyMarkup = (amount) => {
        const numericAmount = Number(amount);
        if (!Number.isFinite(numericAmount)) return "";

        const settings = window?.theme?.shopSettings;
        const moneyFormat = settings?.moneyFormat;
        let formatted;
        if (window?.theme?.Currency?.formatMoney && moneyFormat) {
            formatted = window.theme.Currency.formatMoney(
                Math.round(numericAmount * 100),
                moneyFormat
            );
        } else {
            formatted = new Intl.NumberFormat(
                window?.Shopify?.locale || "en",
                {
                    style: "currency",
                    currency: window?.Shopify?.currency?.active || "CAD",
                    currencyDisplay: "narrowSymbol",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }
            ).format(numericAmount);
        }
        return `<price-money><bdi>${formatted}</bdi></price-money>`;
    };

    const drawerContainers = () =>
        Array.from(
            document.querySelectorAll(".loop-bundle-cart-drawer")
        ).filter((container) => container.isConnected);

    const embeddedCartItems = () => {
        const sources = Array.from(
            document.querySelectorAll("[data-loop-cart-items-json]")
        );
        for (let index = sources.length - 1; index >= 0; index -= 1) {
            try {
                const items = JSON.parse(sources[index].textContent || "[]");
                if (Array.isArray(items)) return items;
            } catch (error) {
                console.warn("Unable to read embedded Loop cart data:", error);
            }
        }
        return null;
    };

    const freshCartItems = async () => {
        const root = window?.Shopify?.routes?.root ?? "/";
        const response = await fetch(`${root}cart.js`, {
            headers: { Accept: "application/json" },
            credentials: "same-origin",
        });
        if (!response.ok) {
            throw new Error(`Unable to load cart (${response.status})`);
        }
        return (await response.json())?.items ?? [];
    };

    const prepareLocalDetails = (bundleItem) => {
        const firstItem = bundleItem.items[0] || {};
        const properties = firstItem.properties || {};
        bundleItem.label =
            properties._bundleName || properties.bundleName || "Meal Bundle";
        bundleItem.image =
            typeof firstItem.image === "string"
                ? firstItem.image
                : firstItem.featured_image?.url || "";
        bundleItem.sellingPlan =
            firstItem.selling_plan_allocation?.selling_plan?.name || "";
        bundleItem.editBtnText = "Edit";
        bundleItem.loopBundleId = bundleItem.bundleId;
        ensureBundleRef(bundleItem);
    };

    const enrichDetails = async (bundleItems) => {
        await Promise.all(
            bundleItems.map(async (bundleItem) => {
                try {
                    const details =
                        await fetchLoopBundleTransactionCartDetails(
                            bundleItem.bundleId
                        );
                    bundleItem.label = details?.label || bundleItem.label;
                    bundleItem.image = details?.image || bundleItem.image;
                    bundleItem.sellingPlan =
                        details?.name || bundleItem.sellingPlan;
                    bundleItem.editBtnText = details?.editBtnText ?? "Edit";
                    bundleItem.loopBundleId =
                        details?.loopBundleId || bundleItem.bundleId;
                    bundleItem.productHandle =
                        details?.product_handle || bundleItem.productHandle;
                    bundleItem.bundleQuantityMapping =
                        details?.variantMap?.[bundleItem.bundleId] || [];
                } catch (error) {
                    console.warn(
                        "Loop bundle details could not be enriched:",
                        error
                    );
                }
            })
        );
    };

    const bundleLink = (bundleItem) => {
        if (bundleItem.isPresetBundleProduct && bundleItem.productHandle) {
            return `https://${window.Shopify.shop}/products/${bundleItem.productHandle}`;
        }
        if (
            bundleItem.loopBundleId &&
            bundleItem.loopBundleId !== bundleItem.bundleId
        ) {
            return `${BUNDLE_LINK_PREFIX}/${bundleItem.loopBundleId}`;
        }
        return `${BUNDLE_LINK_PREFIX}/change/${bundleItem.bundleId}`;
    };

    const drawerTemplate = (bundleItem, index) => {
        const ref = ensureBundleRef(bundleItem);
        const finalAmount = Number(
            bundleItem.final_line_price ?? bundleItem.discounted_price ?? 0
        );
        const originalAmount = Number(bundleItem.amount ?? finalAmount);
        const originalPrice =
            originalAmount > finalAmount
                ? `<s class="price price-item--regular">${moneyMarkup(
                      originalAmount
                  )}</s>`
                : "";
        const quantityMapping = bundleItem.bundleQuantityMapping || [];
        const mealLines = bundleItem.items
            .map((item) => {
                const mapped = quantityMapping.find(
                    (entry) => entry.childProductId === item.id
                );
                const quantity = mapped?.quantity ?? item.quantity ?? "";
                return `<div role="listitem" class="loop-bundle__meal-line" style="display:grid;grid-template-columns:minmax(0,1fr) auto;gap:12px;align-items:baseline;padding:5px 0;line-height:1.35;">
                    <span class="data-cart-item-selling-plan-name" style="min-width:0;overflow-wrap:anywhere;">${escapeHtml(
                        item.title
                    )}</span>
                    <span aria-label="Quantity ${escapeHtml(
                        quantity
                    )}" style="white-space:nowrap;">× ${escapeHtml(
                        quantity
                    )}</span>
                </div>`;
            })
            .join("");

        return `<li class="loop-bundle-item" id="CartDrawerBundleItem-${index}" data-loop-bundle-item data-bundle-ref="${ref}" data-final-price="${Math.round(
            finalAmount * 100
        )}">
            <div class="product-container${
                bundleItem.image ? "" : " no-image"
            }" style="align-items:flex-start;">
                ${
                    bundleItem.image
                        ? `<div><a href="${escapeHtml(
                              bundleLink(bundleItem)
                          )}" class="product-image media-wrapper media-wrapper--small"><div class="media media--adapt" style="--image-ratio-percent:100%;"><img src="${escapeHtml(
                              bundleItem.image
                          )}" alt="${escapeHtml(
                              bundleItem.label
                          )}" width="70" height="70" loading="lazy" is="lazy-image"></div></a></div>`
                        : ""
                }
                <div class="product-description cart-item__details" style="width:100%;min-width:0;">
                    <a href="${escapeHtml(
                        bundleLink(bundleItem)
                    )}" class="cart-item__name h4 break link product-title">${escapeHtml(
                        bundleItem.label
                    )}</a>
                    <div class="product-option loop-bundle__contents" role="list" style="display:block;width:100%;margin-top:8px;">${mealLines}</div>
                    <div class="product-option" style="display:flex;flex-wrap:wrap;gap:8px;align-items:baseline;margin-top:8px;">${originalPrice}<span class="price price--end">${moneyMarkup(
            finalAmount
        )}</span></div>
                    ${
                        bundleItem.sellingPlan
                            ? `<p class="product-option" style="margin-top:4px;">${escapeHtml(
                                  bundleItem.sellingPlan
                              )}</p>`
                            : ""
                    }
                    <div class="cart-item__quantity-wrapper loop-bundle__actions" style="display:flex;align-items:center;gap:12px;margin-top:8px;">
                        ${getEditCartButton(ref, bundleItem.editBtnText)}
                        <button type="button" class="delete-product healthy7-loop-remove-bundle" data-bundle-ref="${ref}" aria-label="Remove ${escapeHtml(
            bundleItem.label || "bundle"
        )}" style="background:none;border:0;padding:0;cursor:pointer;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4H4.25v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></button>
                    </div>
                </div>
            </div>
        </li>`;
    };

    const syncRemoveIcons = (container) => {
        const template = document.querySelector(
            "template[data-loop-remove-icon-template]"
        );
        if (!template) return;
        container
            .querySelectorAll(".healthy7-loop-remove-bundle")
            .forEach((button) => {
                button.innerHTML = template.innerHTML;
                button.setAttribute("data-no-instant", "");
            });
    };

    const paint = (bundleItems) => {
        const html = bundleItems
            .map((bundleItem, index) => drawerTemplate(bundleItem, index + 1))
            .join("");
        const containers = drawerContainers();
        containers.forEach((container) => {
            container.innerHTML = html;
            container.hidden = false;
            container.removeAttribute("aria-busy");
            syncRemoveIcons(container);
        });
        return containers;
    };

    const renderDrawer = async (cartItems = null) => {
        if (!drawerContainers().length) return;
        const requestId = ++drawerRenderRequest;
        try {
            const items = Array.isArray(cartItems)
                ? cartItems
                : embeddedCartItems() ?? (await freshCartItems());
            if (requestId !== drawerRenderRequest) return;

            window.Loop = window.Loop || {};
            window.Loop.bundleCartAllItems = items;
            const bundles = getBundleItemsLoop(items);
            if (!bundles.length) {
                drawerContainers().forEach((container) => {
                    container.replaceChildren();
                    container.hidden = true;
                    container.removeAttribute("aria-busy");
                });
                return;
            }

            bundles.forEach(prepareLocalDetails);
            paint(bundles).forEach((container) =>
                container.setAttribute("aria-busy", "true")
            );
            await enrichDetails(bundles);
            if (requestId === drawerRenderRequest) paint(bundles);
        } catch (error) {
            console.error("Unable to render Loop bundle in cart drawer:", error);
            drawerContainers().forEach((container) =>
                container.removeAttribute("aria-busy")
            );
        }
    };

    const sectionInnerHtml = (html) =>
        new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(".shopify-section")?.innerHTML || "";

    const resyncDrawer = async (miniCart, state) => {
        if (miniCart?.renderContents && state.sections?.["mini-cart"]) {
            try {
                miniCart.renderContents(state);
                return true;
            } catch (error) {
                console.warn("Retrying mini-cart section after render error:", error);
            }
        }
        if (!miniCart?.dataset?.url) return false;
        try {
            const response = await fetch(miniCart.dataset.url, {
                headers: { Accept: "text/html" },
                credentials: "same-origin",
            });
            if (!response.ok) return false;
            const html = sectionInnerHtml(await response.text());
            if (!html) return false;
            miniCart.innerHTML = html;
            await renderDrawer(state.items || []);
            return true;
        } catch (error) {
            console.error("Unable to resync Loop cart drawer:", error);
            return false;
        }
    };

    const removeFromDrawer = async (bundleId, trigger) => {
        const data = getItemKeysByBundleIdLoop(bundleId);
        if (!Object.keys(data.updates).length) return;
        const row = trigger.closest("[data-loop-bundle-item]");
        const miniCart =
            trigger.closest("mini-cart") || document.querySelector("mini-cart");
        const sections = miniCart?.getSectionsToRender
            ? miniCart
                  .getSectionsToRender()
                  .map((section) => section.section)
                  .filter(Boolean)
            : ["mini-cart", "cart-icon-bubble", "mobile-cart-icon-bubble"];

        trigger.disabled = true;
        trigger.setAttribute("aria-busy", "true");
        row?.classList.add("cart-item--removing", "is-pending");
        let committed = false;
        try {
            const root = window?.Shopify?.routes?.root ?? "/";
            const response = await fetch(`${root}cart/update.js`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                credentials: "same-origin",
                body: JSON.stringify({
                    ...data,
                    sections,
                    sections_url: window.location.pathname,
                }),
            });
            const state = await response.json();
            if (!response.ok || state.errors) {
                throw new Error(
                    typeof state.errors === "string"
                        ? state.errors
                        : "Unable to remove bundle"
                );
            }
            committed = true;
            window.Loop.bundleCartAllItems = state.items || [];
            if (!(await resyncDrawer(miniCart, state))) {
                row?.remove();
                await renderDrawer(state.items || []);
            }
        } catch (error) {
            console.error("Unable to remove Loop bundle:", error);
            if (committed) {
                row?.remove();
                return;
            }
            trigger.disabled = false;
            trigger.removeAttribute("aria-busy");
            row?.classList.remove("cart-item--removing", "is-pending");
        }
    };

    window.renderLoopBundleDrawer = renderDrawer;

    document.addEventListener("cartdrawer:opened", () => renderDrawer());
    document.addEventListener("cart:updated", (event) =>
        renderDrawer(event.detail?.cart?.items ?? null)
    );

    document.addEventListener(
        "click",
        (event) => {
            const editButton = event.target.closest?.(
                ".loop-bundle-cart-drawer .loop-edit-bundle-btn"
            );
            if (editButton) {
                const bundleId = bundleIdRegistry.get(
                    editButton.dataset.bundleRef
                );
                if (!bundleId) return;
                event.preventDefault();
                event.stopImmediatePropagation();
                changeBundleCartItems(bundleId);
                return;
            }

            const removeButton = event.target.closest?.(
                ".loop-bundle-cart-drawer .healthy7-loop-remove-bundle"
            );
            if (!removeButton) return;
            const bundleId = bundleIdRegistry.get(
                removeButton.dataset.bundleRef
            );
            if (!bundleId) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            removeFromDrawer(bundleId, removeButton);
        },
        true
    );

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => renderDrawer(), {
            once: true,
        });
    } else {
        queueMicrotask(() => renderDrawer());
    }
})();
